import { Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import { ReactNode } from "react";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";

const useStyles = makeStyles(() =>
  createStyles({
    horizontalCardDescription: {
      color: "#fff",
      textShadow: "none",
      fontSize: 13,
      textAlign: "center",
      padding: "0 10px",
    },
    horizontalCardIconWrap: {
      padding: 15,

      "& svg": {
        marginBottom: -3,
        color: "#fff",
      },
    },
    horizontalCardTitle: {
      textShadow: "none",
      textAlign: "center",
      fontSize: 26,
      fontWeight: 300,
      color: "#fff",
      padding: "0 10px",
    },
    wrapper: {
      background:
        "linear-gradient(135deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.015))",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      backdropFilter: "blur(16px)",
      borderRadius: 15,
      textAlign: "center",
      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.25)",
      padding: 15,
    },
    horizontalCard: {
      marginBottom: 15,
    },
  }),
);

interface CardHorizontalProps {
  icon: ReactNode;
  primary: ReactNode;
  secondary: ReactNode;
}

export default function CardHorizontalComponent({
  icon,
  primary,
  secondary,
}: CardHorizontalProps) {
  const classes = useStyles();
  return (
    <Grid container spacing={0} className={classes.wrapper}>
      <Grid item xs={2} className={classes.horizontalCardIconWrap}>
        {icon}
      </Grid>
      <Grid
        item
        xs={5}
        style={{ borderRight: "1px solid rgba(255,255,255,.2)" }}
      >
        <Typography className={classes.horizontalCardTitle}>
          {primary}
        </Typography>
      </Grid>
      <Grid item xs={5}>
        <Typography className={classes.horizontalCardDescription}>
          {secondary}
        </Typography>
      </Grid>
    </Grid>
  );
}
